/**
 * Presentation-only formatting helpers.
 * No business logic lives here — they only shape data for display.
 */

export const formatRupiah = (value) => {
    const n = parseInt(value, 10);
    return `Rp ${(isNaN(n) ? 0 : n).toLocaleString("id-ID")}`;
};

export const formatNumber = (value) => {
    const n = parseInt(value, 10);
    return (isNaN(n) ? 0 : n).toLocaleString("id-ID");
};

export const formatDate = (value, options = { day: "numeric", month: "short", year: "numeric" }) => {
    if (!value) return "-";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "-";
    return d.toLocaleDateString("id-ID", options);
};

export const formatDateTime = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "-";
    return d.toLocaleString("id-ID");
};

export const formatTime = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
};

/** Human friendly relative time ("2 menit yang lalu"). */
export const timeAgo = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "";
    const diff = Math.floor((Date.now() - d.getTime()) / 1000);
    if (diff < 60) return "baru saja";
    if (diff < 3600) return `${Math.floor(diff / 60)} menit yang lalu`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} jam yang lalu`;
    if (diff < 604800) return `${Math.floor(diff / 86400)} hari yang lalu`;
    return formatDate(value);
};

export const formatBytes = (bytes) => {
    if (!bytes) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};
